import { render, staticRenderFns } from "./receivable_statistics.vue?vue&type=template&id=2a61129d&scoped=true&"
import script from "./receivable_statistics.vue?vue&type=script&lang=js&"
export * from "./receivable_statistics.vue?vue&type=script&lang=js&"
import style0 from "./receivable_statistics.vue?vue&type=style&index=0&id=2a61129d&prod&lang=scss&scoped=true&"
import style1 from "./receivable_statistics.vue?vue&type=style&index=1&id=2a61129d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61129d",
  null
  
)

export default component.exports